import { createZustandStore } from "@bounce/state-management"

type AppFloatingBannerState = {
  visible: boolean
  dismissed: boolean
  toggleBanner: (visible: boolean) => void
  dismissBanner: () => void
}

export const useAppFloatingBanner = createZustandStore<AppFloatingBannerState>({
  name: "useAppFloatingBanner",
  initializer: (set, _get) => ({
    visible: true,
    dismissed: false,
    toggleBanner: (visible: boolean) => set({ visible }),
    dismissBanner: () => set({ dismissed: true }),
    reset: () => set({ visible: true, dismissed: false }),
  }),
  persistStore: true,
})

export const useIsAppFloatingBannerVisible = () => useAppFloatingBanner(state => state.visible && !state.dismissed)
